/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

var _user = require('./user');

var _device = require('./device');

var _post = require('./post');

var _product = require('./product');

function add() {
  return function (dispatch) {
    dispatch({ type: ADD });
  };
}

function minus() {
  return function (dispatch) {
    dispatch({ type: MINUS });
  };
}

module.exports = {
  saveUser: _user.saveUser,
  deleteUser: _user.deleteUser,
  fetchPosts: _post.fetchPosts,
  fetchDeviceProductDetail: _device.fetchDeviceProductDetail,
  addDevice: _device.addDevice,
  getDeviceList: _device.getDeviceList,
  updateDevice: _device.updateDevice,
  deleteDevice: _device.deleteDevice,
  getDeviceDetail: _device.getDeviceDetail,
  getDeviceType: _product.getDeviceType
};

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/redux/actions/index.jsx
// module id = 648
// module chunks = 0